import _get from 'lodash/get';
import { FilterGroupingEnum, SiteAreaFilterInputObject } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import { FieldNames } from '../enums';

interface OptionItem {
  value: string;
  label: string;
  [key: string]: unknown;
}

/**
 * Creates additional filters for site areas query based on filter form values
 * @param filterValues - Values from the filter form
 * @returns Array of SiteAreaFilterInputObject filters
 */
export function createAdditionalFilters(
  filterValues: Values,
): SiteAreaFilterInputObject[] {
  const filters: SiteAreaFilterInputObject[] = [];

  // Process Sectors filter
  const sectors = _get(filterValues, FieldNames.Sectors, []) as OptionItem[];
  if (sectors && sectors.length > 0) {
    const sectorIds = sectors.map((sector) => sector.value);
    filters.push({
      sectorId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: sectorIds },
        filterGroup: 'filter',
      },
    });
  }

  // Process Site filter
  const sites = _get(filterValues, FieldNames.Sites, []) as OptionItem[];
  if (sites && sites.length > 0) {
    const siteIds = sites.map((site) => site.value);
    filters.push({
      siteId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: siteIds },
        filterGroup: 'filter',
      },
    });
  }

  return filters;
}
